
import HttpClient from "../client/httpclient";
import 'regenerator-runtime/runtime';
class TravelRestrictions {
  constructor(DOMelement) {
    try {
      this.el = DOMelement;
      this.origin = this.el.querySelector("#sd-input__origin");
      this.destination = this.el.querySelector("#sd-input__destination");
      this.travelDate = document.getElementById("sd-input__travelDate");
      this.originList = document.querySelector("#OriginDataList");
      this.origin.addEventListener("keyup", this.setValues);
      this.destination.addEventListener("keyup", this.setValues);
      this.button = this.el.querySelector(".check__restrictions-button");
      this.searchURL = this.el.querySelector(".sd-form__inputs").getAttribute("data-action");
      this.submitFormURL = this.el.getAttribute("action");
      this.url = window.location.href.split('/');
      this.urlDestination = this.url.pop() || this.url.pop();
      this.destinationList = document.querySelector("#DestinationDataList");
      this.destinationListOptions = this.destinationList.querySelectorAll("option"); 
      this.destinationsValues = [];
      
      this.destinationListOptions.forEach(item => {
        this.destinationsValues.push(item.value.toLowerCase().replace(' ', '-')) ;
      });

      if(this.destinationsValues.includes(this.urlDestination)){
        let destinationIdx = this.destinationsValues.indexOf(this.urlDestination);
        this.destination.value = this.destinationListOptions[destinationIdx].value;
      }
            
      this.travelDate.addEventListener("input", function (e) {
        e.target.classList.remove("sd-input--error");
        e.target.parentElement.parentElement.childNodes[1].classList.remove("sd-tooltip--error")
      });

      this.button.addEventListener("click", (event) => {
        event.preventDefault();
        this.submitForm();
      });

      this.method = "GET";
      this.submitMethod = "POST";

      if (process.env.NODE_ENV === "development") {
        this.searchURL = "/src/api/origin-api-response.json";
        this.submitFormURL = '/src/api/travel-safe-result.html';
      }
    } catch (error) {
      console.log(error);
    }
  }

  removeErrors = (element) => {
    element.classList.remove('sd-input--error');
    element.parentElement.parentElement.childNodes[1].classList.remove("sd-tooltip--error");
  }

  setValues = async (e) => {
    let input = e.target;
    let value = input.value;
    let dataListContainer = e.target.nextElementSibling;
    let dID = dataListContainer.id;

    input.focus();
    this.removeDataListOptions(dataListContainer);
    this.removeErrors(input);

    let resultsData;
    if (value.length > 2) {
      resultsData = await HttpClient.AsyncGetRequest(this.searchURL + "?q=" + value, this.method)
        .then(result => JSON.parse(result))
        .catch(error => {
          console.error(error)
        });

      if (resultsData) {
        resultsData.forEach(({ airport, cityName, country, cityCode }) => {
          const airports = `<option value="${airport}">${airport}</option>`
          dataListContainer.insertAdjacentHTML('beforeend', airports);

          let combineNameAndCode = `${cityName} - ${cityCode}`
          var exist = document.querySelectorAll("#" + dID + " option[value='" + combineNameAndCode + "']").length > 0;

          if (!exist) {
            const cities = `<option value="${combineNameAndCode}">${combineNameAndCode}</option>`
            dataListContainer.insertAdjacentHTML('beforeend', cities);
          }

          // country
          var existCountry = document.querySelectorAll("#" + dID + " option[value='" + country + "']").length > 0;
          if (!existCountry) {
            const countries = `<option value="${country}">${country}</option>`
            dataListContainer.insertAdjacentHTML('beforeend', countries);
          }
        })
      }
    }
  }

  removeDataListOptions = (dataList) => {
    const resultItems = dataList.querySelectorAll('option');
    resultItems.forEach(item => {
      item.parentElement.removeChild(item)
    });
  }

  displayErrors = (o, d, t) => {
    if (o.value === "") {
      o.classList.add("sd-input--error");
      o.parentElement.parentElement.childNodes[1].classList.add("sd-tooltip--error")
    }
    if (d.value === "") {
      d.classList.add("sd-input--error");
      d.parentElement.parentElement.childNodes[1].classList.add("sd-tooltip--error")
    }
    if (t.value === "") {
      t.classList.add("sd-input--error");
      t.parentElement.parentElement.childNodes[1].classList.add("sd-tooltip--error")
    }
  }
  loadSherpa = (data) => {
    const result = JSON.parse(data);
    var tabsContainer = document.querySelector('#travel-restrictions-results');
    tabsContainer.innerHTML = result.message;
    const elementConfig = {
      placement: "mmb",
      selected: {
        segment: 0,
        extended: false
      },
      features: {
        showResults: true,
        showSegments: true,
        showTitle: false,
        enableSegmentEditor: false,
        showFilterConnection: false,
      },
      segments: this.GetSegments(result),
      "travellers": [
        {
          "vaccinations": [
            {
              "type": "COVID_19",
              "status": "FULLY_VACCINATED", // <---- COVID-19 vaccination
            }
          ],
          "nationality": result.nationality,
        }
      ]
    }
    //Register the onSherpaEvent under the globnal window scope before the script is loaded
    $sherpa.V2.createElement('trip', elementConfig).mount('#sherpa-trip-element');

  }

  GetSegments=(result)=>{    
      //conditional
      var originType = result.isOriginCity === true  ? "airportCode" : "countryCode";
      var destiType = result.isDestCity === true ? "airportCode" : "countryCode";
      const settings = [
        {
          segmentType: 'OUTBOUND',
          origin: {
            [originType] :  result.origin             
          },
          destination: {
            [destiType]: result.destination            
          },
          departureDate: result.traveldate,
      },
      // Return Segment
      {
          segmentType: 'RETURN',
          origin: {
            [destiType] :  result.destination    
          },
          destination: {
            [originType]: result.origin
          },
          departureDate: result.returndate,
      }
    ]//end of settings 
     return settings;      
  }


  submitForm = async () => {
    let o = this.origin;
    let d = this.destination;
    let t = this.travelDate;

    if (o.value !== "" && d.value !== "" && t.value !== "") {
      const data = new FormData(this.el);
      await HttpClient.AsyncPostRequest(this.submitFormURL, data, this.submitMethod)
        .then(tab => {
          this.loadSherpa(tab);
          if (tab === "") {
            tabsContainer.innerHTML = "<h4 class='sd-h4'>No results found</h4>";
          }
          const observer = lozad();
          observer.observe();
        })
        .catch(error => {
          console.error(error)
        });
    } else {
      this.displayErrors(o, d, t);
    }
  };

}



export default TravelRestrictions;
